import classnames from 'classnames'

import { Icon } from '../../../../components'
import { WithTooltip } from '../../../../components/WithTooltip'
import { Button } from '../../../../components/button'

export function LikeButton({
  liked,
  onClick,
  isThumbsUp,
}: {
  liked: boolean | null
  onClick: (liked: boolean) => void
  isThumbsUp: boolean
}) {
  const isActive = (liked && isThumbsUp) || (liked === false && !isThumbsUp)
  return (
    <WithTooltip text={isThumbsUp ? 'Like' : 'Dislike'}>
      <Button
        size="xsmall"
        className="-m-1 bg-transparent disabled:bg-transparent dark:bg-transparent disabled:dark:bg-transparent"
        onClick={() => {
          window.gtag?.('event', 'click', {
            event_category: 'stocks-why-moving',
            event_label: isThumbsUp ? 'like' : 'dislike',
          })
          onClick(isThumbsUp)
        }}
        disabled={isActive}
        rightContent={
          <Icon
            name={isThumbsUp ? 'thumbsUp' : 'thumbsDown'}
            width={16}
            className={classnames({
              'text-finviz-blue': isActive,
              'text-muted-2': !isActive,
            })}
          />
        }
      />
    </WithTooltip>
  )
}
